/**
 * Lightweight carousel using CSS scroll-snap + JS arrow controls
 * Supports looping: when reaching the end, wraps back to the start
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');

    if (!track) return;

    var getScrollAmount = function () {
      var firstChild = track.children[0];
      if (!firstChild) return 300;
      return firstChild.offsetWidth + 24; // card width + gap
    };

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - 5) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (track.scrollLeft <= 5) {
          track.scrollTo({ left: track.scrollWidth - track.clientWidth, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        }
      });
    }
  });
});
